module.exports = __webpack_public_path__ + "img/defence.e13b40d0.svg";